import { useLazyLoadQuery } from 'react-relay';
import { ATLASSIAN_ACCOUNT_USER_QUERY } from '../constants';
import { AtlassianAccountUserQuery } from '../graphql/__generated__/AtlassianAccountUserQuery.graphql';
import useIsForumsModerator from './useIsForumsModerator';

const useIsLoggedInUserAForumsModerator = (): boolean => {
  const loggedInUser = useLazyLoadQuery<AtlassianAccountUserQuery>(
    ATLASSIAN_ACCOUNT_USER_QUERY,
    {},
    { fetchPolicy: 'store-or-network' },
  )?.me?.user;

  return loggedInUser?.accountId
    ? useIsForumsModerator(loggedInUser.accountId)
    : false;
};

export default useIsLoggedInUserAForumsModerator;
